<template>
  <div id="bodyContent" v-html="htmlStr" @click="handlePreviewImg"></div>
</template>

<script setup>
const FILE_HOST = import.meta.env.VITE_FILE_HOST

const props = defineProps({
  contentHTML: {
    required: true
  }
})

// let contentHTML = props.xq.newsContent || props.xq.content;
let htmlStr = props.contentHTML;
if (htmlStr) {
  htmlStr = htmlStr.replace(/src=['"]([^'"]+)[^>]/gi, function(match, capture) {
    if(capture.indexOf('http') === -1){
      return capture = "src=" + FILE_HOST + capture + " ";
    }else{
      return "src=" + capture + " ";
    }
  });
}
htmlStr = htmlStr.replace(/href=['"]([^*'"]+)[^*']/gi,function(match,capture){
    if (!capture.startsWith('mail') && !capture.startsWith('http') && !capture.startsWith('tel')) {
        // todo:再判断是否以.*结尾
        return capture = 'href="' + FILE_HOST + capture + '"'
    } else {
        return match
    }
});


function handlePreviewImg(e) {
  if(e.target.nodeName === 'IMG') {
    console.log(e.target.src)
    // todo： 图片预览组件
  }
}
</script>

<style scoped lang="scss">
#bodyContent {
  font-size: 18px;
  color: #333;
  text-align: left;
  line-height: 1.67;
  margin-top: 50px;
  > ::v-deep(p),
  > ::v-deep(div),{
    //text-indent: 2em;
    margin: 15px 0;
    img, video {
      margin: 0 auto;
      max-width: 100%;
      //margin: 90px auto;
      //display: block;
    }
    video {
      //object-fit: fill;
      width: 900px;
      height: 450px;
      margin: 0 auto;
      display: block;
      background: rgba(0,0,0,.6);
      border-radius: 5px;
    }
  }
> ::v-deep(table){
    border-collapse: collapse;
      td {
        border: 1px solid var(--secondary-text-color);
        text-align: center;
      }
  }
  ::v-deep(ol) {
    padding-left: 20px;
  }
  ::v-deep(.ql-indent-1em),
  ::v-deep(.ql-indent-1){
    text-indent: 1em;
  }
  ::v-deep(.ql-indent-2em),
  ::v-deep(.ql-indent-2){
    text-indent: 2em;
  }
  ::v-deep(.ql-align-justify) {
    text-align: justify;
  }
  ::v-deep(.ql-align-right) {
    text-align: right;
  }
  ::v-deep(.ql-align-left) {
    text-align: left;
  }
  ::v-deep(.ql-align-center) {
    text-align: center;
  }
  ::v-deep(h1) {
    font-size: 26px;
  }
  ::v-deep(h2) {
    font-size: 20px;
  }
}
//与useChangeFontSize相对应
$bigSize: 20px;
$middleSize: 18px;
$smallSize: 16px;
.big {
  font-size: $bigSize!important;
  ::v-deep(p) {
    font-size: $bigSize!important;
    span {
      font-size: $bigSize!important;
    }
  }
}
.middle {
  font-size: $middleSize!important;
  ::v-deep(p) {
    font-size: $middleSize!important;
    span {
      font-size: $middleSize!important;
    }
  }
}
.small {
  font-size: $smallSize!important;
  ::v-deep(p) {
    font-size: $smallSize!important;
    span {
      font-size: $smallSize!important;
    }
  }
}
</style>